import "./Modal.scss";
import Button from "core/buttons/button/Button";
import Icon from "core/icon/Icon";
import ReactDom from "react-dom";
import { FormattedMessage, useIntl } from "react-intl";
import { useEffect, useState } from "react";
import { EVALUATE_OPTIONS } from "constants/constants";
import InputRadioGroup from "core/inputs/input-radio/InputRadioGroup";
import InputText from "core/inputs/input-text/InputText";
import { useMissionBalancesheetContext } from "api/balance-sheet/mission/MissionBalancesheetProvider";

const EvaluateModal = ({ open, onClose, item, sendEvaluationMail }) => {
  const [value, setValue] = useState("davidson_user");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const intl = useIntl();
  const { createMissionBalancesheetWithId } = useMissionBalancesheetContext();

  useEffect(() => {
    if (!item) return;
    setFullName(item.client_contact ?? "");
    setEmail(item.client_contact_email ?? "");
  }, [item]);

  const handleSubmit = () => {
    sendEvaluationMail();

    createMissionBalancesheetWithId({
      missionId: item.mission_id,
      data: { full_name: fullName, email: email },
    });
  };

  if (!open) return null;
  return ReactDom.createPortal(
    <>
      <div className="overlay-style" />
      <div className="backup-modal-style evaluate-modal-custom-width">
        <div className="header">
          <div className="title">
            {intl
              .formatMessage({
                id: "evaluate_mission_contact",
                defaultMessage: "Contact pour l'évaluation de la mission",
              })
              .toUpperCase()}
          </div>
          <Icon color="gray-200" icon="close" onClick={onClose} />
        </div>
        <div className="body">
          <div className="modal-section">
            <hr className="modal-divider" />
            <p className="modal-section-title">
              <FormattedMessage
                id="evaluate_modal_description"
                defaultMessage="À qui souhaitez-vous envoyer cette évaluation ?"
              />
            </p>
          </div>
          <InputRadioGroup
            id="Evaluate-modal"
            isInline={true}
            options={EVALUATE_OPTIONS.map((elm) => ({
              val: elm.val,
              lb: intl.formatMessage(elm.lb),
            }))}
            getSelectedValue={(e) => setValue(e?.target?.value)}
            value={EVALUATE_OPTIONS.val}
          />
          <hr className="modal-divider" />
          <div className="input-group-options">
            <div className="input-row">
              <label htmlFor="evaluate-first-name" className="input-label">
                <FormattedMessage
                  id="evaluate_modal_full_name"
                  defaultMessage="Nom et prénom :"
                />
              </label>
              <InputText
                errors={{}}
                placeholder={{
                  id: "evaluate_modal_full_name_placeholder",
                  defaultMessage: "Nom et prénom",
                }}
                id="evaluate-first-name"
                onChange={(e) => setFullName(e.target.value)}
                value={fullName}
              />
            </div>

            <div className="input-row">
              <label htmlFor="evaluate-email" className="input-label">
                <FormattedMessage
                  id="evaluate_modal.email"
                  defaultMessage="E-mail :"
                />
              </label>
              <InputText
                errors={{}}
                placeholder={{
                  id: "evaluate_modal.email_placeholder",
                  defaultMessage: "Email",
                }}
                id="evaluate-email"
                onChange={(e) => setEmail(e.target.value)}
                value={email}
              />
            </div>
          </div>

          <div className="form-buttons">
            <Button
              className="btn-standard btn-outline"
              onClick={onClose}
              type="button"
              id="button-form-reset"
            >
              <FormattedMessage id="cancel" defaultMessage="Fermer" />
            </Button>
            <Button
              color="btn-medium gray-700"
              type="submit"
              onClick={handleSubmit}
              id="button-form-validation"
            >
              <FormattedMessage id="validate" defaultMessage="Valider" />
            </Button>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("portal")
  );
};

export default EvaluateModal;
